export default {
  // Cookies page
  cookiesTitle: 'Zásady a nastavení cookies',
  cookiesIntro:
    'PlayStock používá soubory cookies a podobné technologie, aby web zůstal stabilní a bezpečný, zlepšil váš zážitek a analyzoval, jak je platforma využívána. Své předvolby spravujte níže.',
  cookiesPrefsTitle: 'Vaše předvolby',
  cookiesRowEssential: 'Nezbytné',
  cookiesRowEssentialDesc: 'Nutné pro základní provoz, ověřování a zabezpečení. Nelze je vypnout.',
  cookiesRowAnalytics: 'Analytické',
  cookiesRowAnalyticsDesc: 'Pomáhají nám pochopit vzorce návštěvnosti, optimalizovat výkon a zlepšit navigaci.',
  cookiesRowMarketing: 'Marketingové',
  cookiesRowMarketingDesc: 'Slouží k doručování cíleného propagačního obsahu a sledování výkonu kampaní napříč sítěmi.',
  cookiesSaved: 'Předvolby uloženy.',
  cookiesSave: 'Uložit předvolby',

  cookiesInUseTitle: 'Používané cookies',
  cookiesColName: 'Název',
  cookiesColProvider: 'Poskytovatel',
  cookiesColPurpose: 'Účel',
  cookiesColType: 'Typ',
  cookiesColExpiry: 'Platnost',

  cookiesGroupEssential: 'Nezbytné (nezbytně nutné)',
  cookiesGroupAnalytics: 'Analytika a výkon',
  cookiesGroupMarketing: 'Marketing a cílení',

  cookieSessionPurpose: 'Udržuje stav aktivní uživatelské relace.',
  cookieCsrfPurpose: 'Zabraňuje útokům typu Cross-Site Request Forgery.',
  cookieGaPurpose: 'Rozlišuje jedinečné uživatele pro analýzu návštěvnosti.',
  cookiePerfPurpose: 'Sleduje doby načítání a latenci.',
  cookieFbpPurpose: 'Sleduje konverze a cílí zobrazování reklam.',

  cookieExpirySession: 'Relace',
  cookieExpiry1Day: '1 den',
  cookieExpiry2Years: '2 roky',
  cookieExpiryPersistent: 'Trvalá',
  cookieExpiry3Months: '3 měsíce',
  cookieTypeHttp: 'HTTP',
  cookieTypeLocalStorage: 'HTML5 Local Storage',

  cookiesNotes:
    'Změna těchto nastavení může vyžadovat opětovné načtení stránky, aby se plně projevila. Úplný přehled o tom, jak nakládáme s vašimi údaji, najdete v našich kompletních zásadách.',
  cookiesReadFullPolicy: 'Přečíst úplné zásady ochrany osobních údajů',

  // Terms page
  termsTitle: 'Obchodní podmínky',
  termsLastUpdated:
    'Naposledy aktualizováno: 24. října 2026. Vítejte na PlayStock. Před použitím platformy si prosím tyto podmínky pečlivě přečtěte.',
  termsToc: 'Obsah',
  termsNeedAssistanceTitle: 'Potřebujete pomoc?',
  termsNeedAssistanceBody: 'Pokud máte k těmto podmínkám dotazy, náš tým podpory je tu pro vás.',
  termsContactSupport: 'Kontaktovat podporu',

  termsS1Title: 'Souhlas s podmínkami',
  termsS1P1:
    'Přístupem k platformě PlayStock nebo jejím užíváním souhlasíte s tím, že jste vázáni těmito obchodními podmínkami a všemi platnými zákony a předpisy. Pokud s jakoukoli částí těchto podmínek nesouhlasíte, je vám zakázáno tento web používat nebo k němu přistupovat.',
  termsS1P2:
    'Tyto podmínky zakládají závaznou právní dohodu mezi vámi a PlayStock. Vyhrazujeme si právo tyto podmínky kdykoli změnit. Pokračováním v užívání platformy po zveřejnění změn potvrzujete, že změny přijímáte a souhlasíte s nimi.',

  termsS2Title: 'Registrace účtu',
  termsS2P1:
    'Pro přístup k některým funkcím platformy si musíte zaregistrovat účet. Zavazujete se poskytnout přesné, aktuální a úplné údaje v průběhu registrace a tyto údaje aktualizovat tak, aby zůstaly přesné, aktuální a úplné.',
  termsS2P2:
    'Nesete výhradní odpovědnost za ochranu hesla, které používáte pro přístup ke svému účtu, a za veškeré činnosti a úkony provedené pod vaším heslem. PlayStock neodpovídá za žádné ztráty ani škody vzniklé v důsledku nedodržení těchto bezpečnostních povinností.',

  termsS3Title: 'Nákupy a platby',
  termsS3P1:
    'Všechny ceny jsou uvedeny v EUR, pokud není uvedeno jinak. Vyhrazujeme si právo odmítnout jakoukoli objednávku, kterou u nás zadáte. Dle vlastního uvážení můžeme omezit nebo zrušit množství zakoupené na osobu, na domácnost nebo na objednávku.',
  termsS3P2:
    'Zavazujete se poskytnout aktuální, úplné a přesné nákupní a účetní údaje pro všechny nákupy. V případě, že objednávku změníme nebo zrušíme, můžeme se vás pokusit informovat prostřednictvím e-mailu uvedeného v době zadání objednávky.',

  termsS4Title: 'Doručení digitálního klíče',
  termsS4P1:
    'Produkty prodávané na PlayStock jsou digitální aktivační klíče doručované elektronicky. Jakmile vaše platba proběhne, klíč je zpřístupněn ve vašem účtu v sekci „Mé objednávky“, obvykle během několika sekund.',
  termsS4P2:
    'Jste odpovědní za aktivaci klíče na správné platformě (např. Steam, Epic Games) a za kontrolu případných regionálních omezení uvedených na stránce produktu před nákupem.',

  termsS5Title: 'Zásady vrácení peněz',
  termsS5P1:
    'Protože digitální klíče jsou po odkrytí nevratné, vrácení peněz je možné pouze u klíčů, které nebyly odkryty ani aktivovány. Odkrytí klíče představuje spotřebování digitálního produktu a znamená vzdání se práva na odstoupení od smlouvy.',
  termsS5P2:
    'Pokud je klíč vadný nebo jej nelze aktivovat z důvodů na straně PlayStock, kontaktujte náš tým podpory; situaci prošetříme a v odůvodněných případech poskytneme náhradní klíč nebo vrácení peněz.',

  termsS6Title: 'Chování uživatele',
  termsS6P1:
    'Zavazujete se nepoužívat platformu k jakýmkoli nezákonným účelům, dále neprodávat klíče získané v rozporu s těmito podmínkami, nepokoušet se obcházet bezpečnostní opatření nebo omezení počtu požadavků ani nenarušovat běžný provoz služby.',
  termsS6P2:
    'Vyhrazujeme si právo pozastavit nebo zrušit účty, které tyto podmínky porušují nebo u nichž se důvodně domníváme, že jsou zapojeny do podvodné či zneužívající činnosti.',

  termsS7Title: 'Duševní vlastnictví',
  termsS7P1:
    'Veškerý obsah na platformě, včetně textů, grafiky, log a softwaru, je majetkem PlayStock nebo jeho poskytovatelů licencí a je chráněn platnými zákony o duševním vlastnictví. Názvy her, grafika a ochranné známky zůstávají majetkem jejich příslušných vlastníků.',

  termsS8Title: 'Omezení odpovědnosti',
  termsS8P1:
    'V maximálním rozsahu povoleném zákonem nenese PlayStock odpovědnost za žádné nepřímé, náhodné, zvláštní ani následné škody vzniklé v souvislosti s vaším užíváním platformy, a to ani v případě, že byl na možnost takových škod upozorněn.',

  termsS9Title: 'Rozhodné právo',
  termsS9P1:
    'Tyto podmínky se řídí a vykládají v souladu s právními předpisy Lotyšska a vy se podřizujete nevýlučné jurisdikci tamních soudů pro řešení jakýchkoli sporů.',

  termsS10Title: 'Kontakt',
  termsS10P1:
    "Dotazy k těmto obchodním podmínkám můžete směřovat na náš tým podpory na adrese support{'@'}playstock.red.",
};
